import { render } from "./PuestoForm.vue?vue&type=template&id=7a569a97&scoped=true"
import script from "./PuestoForm.vue?vue&type=script&lang=js"
export * from "./PuestoForm.vue?vue&type=script&lang=js"

import "./PuestoForm.vue?vue&type=style&index=0&id=7a569a97&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a569a97"]])

export default __exports__